import { ControlPackage } from '@controls/Base';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { createElement } from 'react';
import Control from './Control';
import RadioList from './RadioList';
import Props from './Props';
import PropsDescriptor from './PropsDescriptor';
import renderFDO from './RenderFDO';

const createRadioList = (parentId?: number | undefined): Control => ({
    globalId: -1,
    parentId,
    name: 'NewRadioList',
    type: 'radio-list',
    properties: {
        position: {
            placement: 'precise',
            top: 0,
            left: 0,
            width: 96,
            height: 32,
        },
    },
});

const upgradePropsVersion = (props: Props) => ({ ...props });

const radioListPackage: ControlPackage<Props, Control> = {
    type: 'radio-list',
    icon: solid('list-ul'),
    canHaveChildren: true,
    canHaveAction: false,
    validParentTypes: ['window'],
    factory: createRadioList,
    propDescriptors: PropsDescriptor,
    // eslint-disable-next-line react/no-children-prop
    renderDesigner: (controlId, children) => createElement(RadioList, { controlId, children }),
    renderFDO,
    upgradePropsVersion,
};

export default radioListPackage;
